import { render, staticRenderFns } from "./smart_route_assignments_tbn.vue?vue&type=template&id=2d904f04&scoped=true&"
import script from "./smart_route_assignments_tbn.vue?vue&type=script&lang=js&"
export * from "./smart_route_assignments_tbn.vue?vue&type=script&lang=js&"
import style0 from "./smart_route_assignments_tbn.vue?vue&type=style&index=0&id=2d904f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d904f04",
  null
  
)

export default component.exports